module.exports = __webpack_public_path__ + "img/filters.fe244aa2.svg";